<template>
  <div class="home view-conten">
    <!-- 首页轮播banner -->
    <div class="top-banner">
      <el-carousel trigger="click" arrow="never" height="368px">
        <el-carousel-item>
          <div class="top-banner-item">
            <img
              class="banner-img"
              src="@/assets/home/banner1.png"
              alt=""
              srcset=""
            />
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="top-banner-item">
            <img
              class="banner-img"
              src="@/assets/home/banner2.jpg"
              alt=""
              srcset=""
            />
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="top-banner-item">
            <img
              class="banner-img"
              src="@/assets/home/banner3.jpg"
              alt=""
              srcset=""
            />
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="banner-title">
        <div class="main-title">
          告别传统零和博弈，让供应链从“砍价对手”变成“共生伙伴”
        </div>
        <div class="subtitle">供应商管理 / 智慧寻源 / 订单协同 / 结算</div>
        <div class="title-btn" @click="handleContact">预约演示</div>
      </div>
    </div>
    <!-- 内容 -->
    <div class="home-content">
      <!-- 客户案例 -->
      <div class="process-control">
        <top-title num="01" cnName="采购全景" enName="Process Control" />
        <!-- 客户案例轮播 -->
        <div class="process-control-card">
          <img
            class="card-img"
            src="@/assets/home/process-control.png"
            alt=""
          />
          <div class="card-content purchase-plan">
            汇总集团、企业、部门各类物资采购计划
          </div>
          <div class="card-content purchase-find-source">
            多种寻源方案组合，助力集团企业提高沟通效率，降低采购成本
          </div>
          <div class="card-content contract-manage">
            合同全生命周期管理，各个阶段到期、超期预警提醒
          </div>
          <div class="card-content order-synergy">
            基于合同生成采购订单，与供应商约定发货计划，完成最终收货、质检、入库与退换货
          </div>
          <div class="card-content acount-settle">
            供应商进行采购入库对账、VMI对账开具发票，财务确认后完成最终付款
          </div>
          <div class="card-content supplier-manage">
            供应商全生命周期管理准入、评审、绩效、红黄牌、冻结、淘汰
          </div>
        </div>
      </div>

      <!-- 产品特点 -->
      <div class="product-trait">
        <top-title num="02" cnName="产品特点" enName="Product Features" />
        <div class="title-intr">供应商、寻源、订单 三维管理模式</div>
        <div class="product-trait-card">
          <el-row :gutter="20">
            <el-col :span="8">
              <div class="card-item">
                <img
                  class="card-item-img"
                  src="@/assets/home/icon-2-1.png"
                  alt=""
                />
                <div class="card-item-info">
                  <div class="info-title">供应商管理</div>
                  <div class="info-content">
                    高效全面的供应商全生命周期管理，帮助您的建立优质且完善的供应商管理体系。
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="card-item">
                <img
                  class="card-item-img"
                  src="@/assets/home/icon-2-2.png"
                  alt=""
                />
                <div class="card-item-info">
                  <div class="info-title">智慧寻源</div>
                  <div class="info-content">
                    从传统采购到数字化的转换，询比价，招投标流程全程透明。
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="card-item">
                <img
                  class="card-item-img"
                  src="@/assets/home/icon-2-3.png"
                  alt=""
                />
                <div class="card-item-info">
                  <div class="info-title">订单协同</div>
                  <div class="info-content">
                    实现与供应商之间的深度协同，数据高效流动，推动企业内部采购、跨职能团队以及供应商之间的良性协作，提高采购效率和效益。
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20" style="margin-top: 20px">
            <el-col :span="8">
              <div class="card-item">
                <img
                  class="card-item-img"
                  src="@/assets/home/icon-2-4.png"
                  alt=""
                />
                <div class="card-item-info">
                  <div class="info-title">即时通讯</div>
                  <div class="info-content">
                    在自研移动APP的前提下，还深度集成了企业微信，钉钉等即时通讯软件，更高效的提高企业与企业之间，企业与业务负责人之间的协同
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="card-item">
                <img
                  class="card-item-img"
                  src="@/assets/home/icon-2-5.png"
                  alt=""
                />
                <div class="card-item-info">
                  <div class="info-title">采购分析</div>
                  <div class="info-content">
                    系统内置多种经过良好实践的数据报表，能够让使用者快速获取数据信息。
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="card-item">
                <img
                  class="card-item-img"
                  src="@/assets/home/icon-2-6.png"
                  alt=""
                />
                <div class="card-item-info">
                  <div class="info-title">相互贯通</div>
                  <div class="info-content">
                    消除“信息孤岛”，和其他信息系统打通，使信息流淌，避免员工重复性工作。
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- 产品价值 -->
      <div class="product-value">
        <top-title num="03" cnName="产品价值" enName="Product Features" />
        <div class="title-intr">三维管理模式提升企业效率</div>
        <div class="product-value-select">
          <div class="select-card">
            <div
              :class="[
                'select-card-item',
                { active: productValueIndex == index },
              ]"
              v-for="(item, index) in productValueData"
              :key="item.id"
              @mouseover="handleSelect(index)"
            >
              <div>{{ item.name }}</div>
              <img src="@/assets/home/arrow-right.png" alt="" />
            </div>
          </div>
          <div class="view-card">
            <!-- 行业痛点 -->
            <el-card shadow="always" class="disadvantages-card">
              <div class="disadvantages-card-title">行业痛点</div>
              <div
                class="disadvantages-card-item"
                :key="index"
                v-for="(item, index) in productValueData[productValueIndex]
                  .disadvantages"
              >
                <img
                  class="disadvantages-img"
                  src="@/assets/home/icon-3-1.png"
                  alt=""
                />
                <div class="disadvantages-tip">{{ item }}</div>
              </div>
            </el-card>

            <!-- 解决方案/优势 -->
            <el-card shadow="always" class="advantages-card">
              <div class="advantages-card-top">
                <div class="advantages-card-title">解决方案/优势</div>
                <div
                  class="advantages-card-item"
                  :key="index"
                  v-for="(item, index) in productValueData[productValueIndex]
                    .advantages"
                >
                  <img
                    class="advantages-img"
                    src="@/assets/home/icon-3-2.png"
                    alt=""
                  />
                  <div class="advantages-tip">
                    {{ item.content }}
                    <font class="advantages-highlight">{{
                      item.highLight
                    }}</font>
                  </div>
                </div>
              </div>
              <div class="advantages-card-bottom">
                <div>
                  {{ productValueData[productValueIndex].advantagesTitle }}
                  <span class="card-bottom-import"
                    >{{ productValueData[productValueIndex].advantagesContent }}
                  </span>
                </div>
              </div>
            </el-card>
          </div>
        </div>
      </div>

      <!-- 安全 -->
      <div class="service-content">
      <div class="product-safe">
        <top-title num="04" cnName="安全" enName="Security" />
          <div class="service-intr-card">
        <div class="card-title">
          <div class="card-title-name">私有化部署</div>
          <div class="card-title-content">
              <p> 功能更灵活，管理模式更成熟，必支持企业个性化定制</p>
              <p> 安全性更高，系统部署在本地，数据更安全可控</p>
              <p> 拓展性强，企业能自主二次开发</p>
          </div>
        </div>
        <!-- 图片区 -->
       <img src="@/assets/home/banner4.png" alt="" style="" />
      </div>
      </div>
    </div>
    </div>
    <registerDialog :show.sync="show" />
  </div>
</template>

<script>
import topTitle from '@/components/top-title'
import registerDialog from '@/components/register-dialog'

import 'swiper/swiper.scss'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  components: {
    swiper,
    swiperSlide,
    topTitle,
    registerDialog
  },
  data () {
    return {
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination', // 与slot="pagination"处 class 一致
          clickable: true, // 轮播按钮支持点击
          dynamicBullets: true
        }
      },
      productValueData: [
        {
          id: 1001,
          name: '需求部门',
          disadvantages: [
            '需求多样，物料选项少',
            '采购流程冗长，频繁线下沟通',
            '需求零散，采购成本高'
          ],
          advantages: [
            { content: '搭建目录化电商化商城', highLight: '更多资源' },
            {
              content: '审批流程、物流流程线上实时同步跟踪',
              highLight: '更快到货'
            },
            { content: '实现集采，全程把控更好质量', highLight: '更低成本' }
          ],
          advantagesTitle: '需求及时率',
          advantagesContent: '提升50%'
        },
        {
          id: 1002,
          name: '采购部门',
          disadvantages: [
            '难以确定合适供应商及价格',
            '很难提出业务需求 只能被动采购',
            '供应商多，流程长风险难把控'
          ],
          advantages: [
            { content: '多种寻源方式', highLight: '轻松获供比价定价' },
            { content: '数据赋能决策', highLight: '提前布局采购' },
            { content: '异常自动通知', highLight: '风险预警' }
          ],
          advantagesTitle: '采购成本',
          advantagesContent: '降低15%'
        },
        {
          id: 1003,
          name: '管理层',
          disadvantages: [
            '参与采购部分审批 但对采购全貌不了解',
            '要求各部门降本增效，但无实质性效果',
            '公司现有资源及采购目录不清晰'
          ],
          advantages: [
            { content: '采购全程记录', highLight: '运营情况可视化' },
            { content: '内部采购员工', highLight: '绩效可视化' },
            { content: '供应商资源及外部供应商', highLight: '表格可视化' }
          ],
          advantagesTitle: '数据获取效率',
          advantagesContent: '提升80%'
        }
      ],
      productValueIndex: 0,
      swiperOption: {
        loop: true,
        autoplay: {
          // disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        lazy: {
          lazy: true
        }
      },
      show: false
    }
  },
  methods: {
    handleSelect (index) {
      this.productValueIndex = index
    },
    handleContact () {
      this.show = true
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  // height: 100vh;
  .top-banner {
    position: relative;
    .el-carousel
      ::v-deep
      .el-carousel__indicator--horizontal
      .el-carousel__button {
      width: 24px;
      height: 6px;
      border-radius: 3px;
    }
    ::v-deep .is-active .el-carousel__button {
      background-color: #0c55dd;
    }
    .top-banner-item {
      height: 368px;
      .banner-img {
        width: 100%;
        height: 100%;
      }
    }
    .banner-title {
      color: #ffffff;
      position: absolute;
      z-index: 2;
      width: 1200px;
      margin: 0 auto;
      top: 62px;
      left: 0;
      right: 0;
      .main-title {
        font-size: 42px;
        color: #ffffff;
        line-height: 75px;
      }
      .subtitle {
        margin-top: 12px;
        font-size: 30px;
        color: #ffffff;
      }
      .title-btn {
        margin-top: 40px;
        width: 134px;
        height: 40px;
        background: #0c55dd;
        text-align: center;
        line-height: 40px;
        cursor: pointer;
        border-radius: 3px;
      }
    }
  }
  .home-content {
    // 采购全景
    .process-control {
      .process-control-card {
        padding-top: 52px;
        margin: 0 auto;
        width: 1200px;
        position: relative;
        text-align: center;
        .card-img {
          height: 355px;
          width: 780px;
          margin-bottom: 124px;
        }
        .card-content {
          font-size: 14px;
          color: #444444;
          line-height: 24px;
          width: 196px;
          text-align: right;
          position: absolute;
        }
        .purchase-plan {
          top: 35px;
          left: 180px;
        }
        .purchase-find-source {
          top: 35px;
          right: 160px;
        }
        .contract-manage {
          top: 230px;
          right: 0;
          text-align: left;
        }
        .order-synergy {
          bottom: 70px;
          right: 220px;
          text-align: left;
        }
        .acount-settle {
          bottom: 70px;
          left: 160px;
        }
        .supplier-manage {
          left: 0;
          top: 180px;
        }
      }
    }

    // 产品特点
    .product-trait {
      padding-top: 30px;
      background: url("../assets/home/bg.jpg") no-repeat 100% 100%;
      background-size: cover;
      min-height: 690px;
      .title-intr {
        margin-top: 24px;
        font-size: 16px;
        color: #777777;
        text-align: center;
        line-height: 24px;
        margin-bottom: 53px;
      }
      .product-trait-card {
        margin: 0 auto;
        width: 1200px;
        .card-item {
          background-color: #fff;
          height: 111px;
          display: flex;
          padding: 37px;
          .card-item-img {
            width: 38px;
            height: 38px;
            margin-right: 16px;
          }
          .card-item-info {
            .info-title {
              font-size: 18px;
              color: #000000;
              font-weight: bold;
              margin-bottom: 12px;
            }
            .info-content {
              font-size: 14px;
              color: #777777;
              line-height: 24px;
            }
          }
        }
      }
    }

    // 产品价值
    .product-value {
      padding-top: 30px;
      .title-intr {
        margin-top: 24px;
        font-size: 16px;
        color: #777777;
        text-align: center;
        line-height: 24px;
      }
      .product-value-select {
        padding-top: 52px;
        margin: 0 auto;
        width: 1200px;
        display: flex;
        margin-bottom: 72px;
        .select-card {
          width: 254px;
          background-image: linear-gradient(
            180deg,
            #ffffff 0%,
            #f9fafd 61%,
            #ffffff 100%
          );
          margin-right: 54px;
          .select-card-item {
            font-size: 28px;
            color: #737a88;
            padding-left: 24px;
            padding-right: 24px;
            height: 120px;
            line-height: 120px;
            cursor: pointer;
            opacity: 1;
            display: flex;
            justify-content: space-between;
            align-items: center;

            &:hover {
              background: url("../assets/home/product-value.png");
              transition: 1s;
              color: #fff;
            }
          }
          .active {
            background: url("../assets/home/product-value.png");
            color: #fff;
          }
        }
        .view-card {
          display: flex;
          align-items: center;
          height: 420px;
          .disadvantages-card {
            width: 430px;
            height: 100%;
            margin-right: 32px;
            border-top: 6px solid #ef2626;
            .disadvantages-card-title {
              margin-top: 40px;
              margin-bottom: 41px;
              font-size: 30px;
              color: #333333;
              font-weight: bold;
            }
            .disadvantages-card-item {
              display: flex;
              margin-bottom: 43px;
              align-items: center;
              .disadvantages-img {
                margin-right: 16px;
              }
              .disadvantages-tip {
                font-size: 16px;
                color: #444444;
              }
            }
          }
          .advantages-card {
            width: 430px;
            height: 100%;
            border-top: 6px solid #1c60df;
            ::v-deep .el-card__body {
              padding: 0;
              height: 100%;
            }
            .advantages-card-top {
              padding: 16px 24px 24px;
              .advantages-card-title {
                margin-top: 40px;
                margin-bottom: 41px;
                font-size: 30px;
                color: #333333;
                font-weight: bold;
              }
              .advantages-card-item {
                display: flex;
                margin-bottom: 43px;
                align-items: center;
                .advantages-img {
                  margin-right: 16px;
                }
                .advantages-tip {
                  font-size: 16px;
                  color: #444444;
                  .advantages-highlight {
                    color: #1c60df;
                    font-weight: bold;
                  }
                }
              }
              .advantages-card-item:last-child {
                margin-bottom: 0;
              }
            }
            .advantages-card-bottom {
              height: calc(100% - 310px);
              display: flex;
              justify-content: center;
              align-items: center;
              background: url("../assets/home/bg3.png") no-repeat 100% 100%;
              .card-bottom-import {
                font-size: 36px;
                color: #1c60df;
                font-weight: bold;
              }
            }
          }
        }
      }
    }
    // 安全
    .product-safe {
      width: 100%;
      padding-top: 30px;
      background: url("../assets/home/safe-bg.jpg") no-repeat center center;
      background-size: cover;
      min-height: 421px;
      .title-intr {
        margin-top: 24px;
        font-size: 16px;
        color: #777777;
        text-align: center;
        line-height: 24px;
        margin-bottom: 52px;

      }
      .product-safe-icon {
        padding-bottom: 74px;
        margin: 0 auto;
        width: 1200px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .product-safe-icon-item {
          // display: flex;
          // justify-content: center;
          // align-items: center;
        }
      }
    }
  }
}

.service-content {
    margin: 0 auto;
    width: 1200px;
    padding-top: 53px;
    .service-intr-card {
      display: flex;
      margin-bottom: 50px;
      .card-title {
        width: 670px;
        .card-title-name {
          margin-top: 93px;
          font-size: 28px;
          color: #333333;
          font-weight: bolder;
        }
        .card-title-content {
          margin-top: 22px;
          width: 601px;
          font-size: 16px;
          color: #333333;
          line-height: 28px;
        }
      }
      img {
        height: 300px;
        margin-left: -145px;
      }
    }
    .service-intr-card:nth-child(2n) .card-title {
      padding-left: 42px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/home.vue